import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { theme } from "../../theme"; // 🟢 BỌC THEME GỐC ĐỂ BẢO VỆ NAVBAR
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    Grid, Card, CardContent, Typography, Stack, Chip, Divider, CircularProgress, TableContainer
} from "@mui/material";
import { AccessTime, CasinoOutlined, AnalyticsOutlined, RefreshOutlined, GroupOutlined } from "@mui/icons-material";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { t } from "i18next";
import { GetNameChoose } from "../../funcUtils";

// ==========================================
// ĐÃ ĐỔI THEME SANG FONT "PLUS JAKARTA SANS" CỰC XỊN
// ==========================================
const metronicTheme = createTheme({
    palette: {
        background: { default: "#F5F8FA", paper: "#FFFFFF" }, 
        text: { primary: "#181C32", secondary: "#7E8299" }, 
        primary: { main: "#1B84FF", light: "#F1FAFF" },
        success: { main: "#50CD89", light: "#E8FFF3" },
        danger: { main: "#F1416C", light: "#FFF5F8" },
        warning: { main: "#FFC700", light: "#FFF8DD" },
        info: { main: "#7239EA", light: "#F8F5FF" }
    },
    typography: { 
        fontFamily: "'Plus Jakarta Sans', sans-serif" 
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: { borderRadius: "12px", boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.03)", border: "1px solid #E4E6EF" }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: { borderBottom: "1px solid #EFF2F5 !important", padding: "14px 12px", color: "#3F4254", fontSize: "0.85rem", fontFamily: "'Plus Jakarta Sans', sans-serif !important" }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: { fontFamily: "'Plus Jakarta Sans', sans-serif" }
            }
        }
    }
});

axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

function SetTX() {
    const [list30, setList30] = useState();
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    
    const [second, setSecond] = useState(60);
    const [minute, setMinute] = useState(0); 
    
    const [start, setStart] = useState(false);
    const [dulieunhap, setDulieunhap] = useState(new Date());
    const [update, setUpdate] = useState(0);
    const [current, setCurrent] = useState(null);
    const [total, setTotal] = useState(null);

    const [selectedDice, setSelectedDice] = useState([]);
    const [kq, setKQ] = useState(""); 

    const date = new Date();
    
    function formatDate(m) {
        if (!m) return "";
        const d = new Date(m);
        return `${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)} ${("0" + d.getDate()).slice(-2)}/${("0" + (d.getMonth() + 1)).slice(-2)}`;
    }

    // Tự động dịch mã cược thành tên cho dễ nhìn
    const getBetLabel = (stateStr) => {
        if (!stateStr) return "";
        const map = { "3": "TÀI", "4": "XỈU", "1": "CHẴN", "2": "LẺ" };
        const states = stateStr.split(" ");
        return states.map(s => map[s] || s).join(" ");
    };
    
    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/TX60s/list30bet`).then((res) => setList30(res.data.data)).catch(() => setList30(null));
        axios.get(`${process.env.REACT_APP_API_URL}/TX60s/getadmin`)
            .then((res) => { if(res.data?.data?.[0]) setBet(res.data.data[0]); })
            .catch(() => {});
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/TX60s/getadmin`).then((res) => {
            if(res.data?.data?.[0]) {
                setBet(res.data.data[0]);
                setDulieunhap(new Date(res.data.data[0].createdAt));
                setStart(true);
            }
        }).catch(() => {});
        
        axios.get(`${process.env.REACT_APP_API_URL}/TX60s/getallbet`, {}).then((res) => setTotal(res.data.data)).catch(() => setTotal(null));
        reloadHistorySilently();
        axios.get(`${process.env.REACT_APP_API_URL}/TX60s/getcurrent`).then((res) => setCurrent(res.data.data)).catch(() => {});
    }, []);
    
    useEffect(() => {
        const timer = setInterval(() => {
            if (Math.floor(60 - (new Date() - dulieunhap) / 1000) < 0) {
                axios.get(`${process.env.REACT_APP_API_URL}/TX60s/getadmin`).then((res) => {
                    if(res.data?.data?.[0]) {
                        setBet(res.data.data[0]);
                        setDulieunhap(new Date(res.data.data[0].createdAt));
                    }
                }).catch(() => {});
                
                axios.get(`${process.env.REACT_APP_API_URL}/TX60s/getallbet`, {}).then((res) => setTotal(res.data.data)).catch(() => setTotal(null));
                reloadHistorySilently();
                axios.get(`${process.env.REACT_APP_API_URL}/TX60s/getcurrent`).then((res) => setCurrent(res.data.data)).catch(() => {});
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);
    
    useEffect(() => {
        let curTime_second = Math.floor(60 - (date - dulieunhap) / 1000);
        let myTimeout;

        if (curTime_second <= 60 && curTime_second >= 0) {
            setSecond(curTime_second);
            setMinute(0); 
            setStart(true);
            return () => clearTimeout(myTimeout);
        } else {
            myTimeout = setTimeout(() => setUpdate(update + 1), 500);
        }
    }, [update, dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(60 - (date - dulieunhap) / 1000);
        let myTimeout = 0;
        
        if (start) {
            setSecond(curTime_second);
            setMinute(0); 
            
            if (curTime_second > 60 || curTime_second <= 0) {
                setStart(false);
                setMinute(0); 
                setSecond(0); 
                return () => clearTimeout(myTimeout);
            }
            
            myTimeout = setTimeout(() => {
                setSecond(second - 1);
                axios.get(`${process.env.REACT_APP_API_URL}/TX60s/getcurrent`).then((res) => setCurrent(res.data.data)).catch(() => setCurrent(null));
            }, 1000);
        }
        return () => clearTimeout(myTimeout);
    }, [second, start, dulieunhap]);

    const handleQuickSubmit = (resultString) => {
        if (!bet) return;
        const formData = { id_bet: bet._id, result: resultString };
        axios.post(`${process.env.REACT_APP_API_URL}/TX60s/update`, formData)
            .then(() => {
                swal(t('success'), `Đã set kết quả thành công!`, "success");
                reloadHistorySilently();
            })
            .catch(() => swal(t('error'), "Có lỗi xảy ra!", "error"));
    };

    // Hàm cập nhật kết quả AI (cho Xúc Xắc 60s)
    const handleAISubmit = (id_bet, aiResultString) => {
        const formData = { id_bet: id_bet, ai_result: aiResultString };
        axios.post(`${process.env.REACT_APP_API_URL}/TX60s/update`, formData)
            .then(() => {
                swal(t('success'), `Đã thay đổi kết quả AI thành công!`, "success");
                reloadHistorySilently();
            })
            .catch(() => swal(t('error'), "Có lỗi xảy ra!", "error"));
    };

    const handleDiceClick = (num) => {
        if (selectedDice.length < 3) setSelectedDice([...selectedDice, num]);
    };
    const clearDice = () => setSelectedDice([]);
    const handleDiceSubmit = () => {
        if (!bet) return;
        if (selectedDice.length !== 3) return swal("Lỗi", "Vui lòng chọn đủ 3 viên xúc xắc!", "warning");
        handleQuickSubmit(selectedDice.join(""));
        setSelectedDice([]); 
    };

    const handleManualSubmit = (e) => {
        e.preventDefault();
        if (!bet || !kq) return;
        const digits = kq.replace(/[^1-6]/g, '');
        if(digits.length !== 3) return swal("Lỗi", "Vui lòng nhập đúng 3 số từ 1 đến 6 (VD: 123)", "warning");
        handleQuickSubmit(digits);
        setKQ(""); 
    };

    function thongke(num) {
        if (!current) return 0;
        let totalMoney = 0;
        current.forEach((item) => {
            const states = item.state.split(" ").map(Number);
            if (states.includes(num)) totalMoney += item.money / states.length;
        });
        return Number(totalMoney).toLocaleString("vi-VN");
    }

    const sumDice = selectedDice.reduce((a, b) => a + b, 0);
    const txLabel = selectedDice.length === 3 ? (sumDice > 10 ? "TÀI" : "XỈU") : "...";
    const clLabel = selectedDice.length === 3 ? (sumDice % 2 === 0 ? "CHẴN" : "LẺ") : "...";
    const txColor = sumDice > 10 ? "red" : "blue"; 
    
    const isDangerTime = second <= 10;
    
    const renderDiceFace = (num) => {
        const dot = <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#fff' }} />;
        const faces = {
            1: <Box display="flex" justifyContent="center" alignItems="center" height="100%">{dot}</Box>,
            2: <Box display="flex" justifyContent="space-between" p={1.2}  height="100%"><Box alignSelf="flex-start">{dot}</Box><Box alignSelf="flex-end">{dot}</Box></Box>,
            3: <Box display="flex" justifyContent="space-between" p={1.2} height="100%"><Box alignSelf="flex-start">{dot}</Box><Box alignSelf="center">{dot}</Box><Box alignSelf="flex-end">{dot}</Box></Box>,
            4: <Box display="flex" justifyContent="space-between" p={1.2} height="100%"><Stack justifyContent="space-between">{dot}{dot}</Stack><Stack justifyContent="space-between">{dot}{dot}</Stack></Box>,
            5: <Box display="flex" justifyContent="space-between" p={1.2} height="100%"><Stack justifyContent="space-between">{dot}{dot}</Stack><Box alignSelf="center">{dot}</Box><Stack justifyContent="space-between">{dot}{dot}</Stack></Box>,
            6: <Box display="flex" justifyContent="space-between" p={1.2} height="100%"><Stack justifyContent="space-between">{dot}{dot}{dot}</Stack><Stack justifyContent="space-between">{dot}{dot}{dot}</Stack></Box>,
        };
        return (
            <Box sx={{ 
                width: 45, height: 45, backgroundColor: '#EF4444', borderRadius: '8px', 
                boxShadow: 'inset 0 -3px 0 rgba(0,0,0,0.2), 0 4px 8px rgba(239, 68, 68, 0.4)', cursor: 'pointer',
                transition: 'transform 0.1s', '&:hover': { transform: 'scale(1.05)' }, '&:active': { transform: 'scale(0.95)' }
            }} onClick={() => handleDiceClick(num)}>
                {faces[num]}
            </Box>
        );
    };

    return (
        // 🟢 BỌC THEME GỐC Ở ĐÂY ĐỂ BẢO VỆ NAVBAR KHÔNG BỊ IN ĐẬM
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                
                {/* 🟢 BỌC THEME MỚI Ở TRONG ĐỂ LÀM ĐẸP GIAO DIỆN CHÍNH */}
                <ThemeProvider theme={metronicTheme}>
                    <style>{`
                        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                        
                        .safe-tx-zone * { 
                            text-align: left !important; 
                            box-sizing: border-box; 
                            font-family: 'Plus Jakarta Sans', sans-serif !important; 
                        }
                        .safe-tx-zone input { 
                            text-align: center !important; 
                        }
                    `}</style>

                    <Box className="safe-tx-zone" component="main" sx={{ flexGrow: 1, py: 4, backgroundColor: 'background.default', minHeight: 'calc(100vh - 70px)' }}>
                        <Container maxWidth="xl">
                            
                            <Box mb={4} display="flex" justifyContent="space-between" alignItems="center">
                                <Box>
                                    <Typography variant="h4" fontWeight="800" color="#181C32">TÀI XỈU 60S</Typography>
                                    <Typography variant="body2" color="text.secondary">Kiểm soát kết quả và xem thống kê cược theo thời gian thực</Typography>
                                </Box>
                                <Button variant="outlined" startIcon={<RefreshOutlined />} onClick={() => window.location.reload()} sx={{ borderRadius: '8px', fontWeight: 700, textTransform: 'none' }}>
                                    Làm mới
                                </Button>
                            </Box>

                            <Grid container spacing={3} mb={4}>
                                {/* PANEL TRÁI */}
                                <Grid item xs={12} lg={5}>
                                    <Card sx={{ height: '100%', backgroundColor: '#FFFFFF' }}>
                                        <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', height: '100%' }}>
                                            
                                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
                                                <Box>
                                                    <Typography variant="caption" fontWeight="800" color="#A1A5B7" sx={{ textTransform: 'uppercase', letterSpacing: '1px' }}>Kỳ quay hiện tại</Typography>
                                                    {bet ? (
                                                        <Typography variant="h5" fontWeight="800" color="#1B84FF">#{bet.id_bet}</Typography>
                                                    ) : (
                                                        <Typography variant="h6" fontWeight="700" color="text.secondary">{t('waiting')}...</Typography>
                                                    )}
                                                </Box>
                                                <Chip 
                                                    icon={<AccessTime sx={{ fontSize: '16px !important', color: isDangerTime ? '#FFF !important' : 'inherit' }} />} 
                                                    label={`00:${second < 10 ? '0' : ''}${second}`} 
                                                    sx={{ 
                                                        backgroundColor: isDangerTime ? '#F1416C' : '#36db15', 
                                                        color: isDangerTime ? '#FFFFFF' : '#ffffff', 
                                                        fontWeight: 800, fontSize: '1.5rem', py: 3, px: 1, borderRadius: '12px',
                                                        animation: isDangerTime ? 'pulse 1s infinite' : 'none',
                                                        '@keyframes pulse': { '0%': { opacity: 1 }, '50%': { opacity: 0.5 }, '100%': { opacity: 1 } }
                                                    }} 
                                                />
                                            </Box>

                                            <Divider sx={{ mb: 3 }} />

                                            <Typography variant="subtitle1" fontWeight="800" color="#181C32" mb={2} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <AnalyticsOutlined color="primary" /> Phân tích cửa cược
                                            </Typography>

                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Box sx={{ p: 2, borderRadius: '12px', backgroundColor: '#FFF5F8', border: '1px solid #FCA5A5' }}>
                                                        <Typography variant="caption" fontWeight="800" color="#F1416C">TỔNG TÀI</Typography>
                                                        <Typography variant="h6" fontWeight="800" color="#181C32">{thongke(3)} <span style={{fontSize: '12px', color: '#A1A5B7'}}>đ</span></Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box sx={{ p: 2, borderRadius: '12px', backgroundColor: '#F1FAFF', border: '1px solid #93C5FD' }}>
                                                        <Typography variant="caption" fontWeight="800" color="#1B84FF">TỔNG XỈU</Typography>
                                                        <Typography variant="h6" fontWeight="800" color="#181C32">{thongke(4)} <span style={{fontSize: '12px', color: '#A1A5B7'}}>đ</span></Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box sx={{ p: 2, borderRadius: '12px', backgroundColor: '#E8FFF3', border: '1px solid #86EFAC' }}>
                                                        <Typography variant="caption" fontWeight="800" color="#50CD89">TỔNG CHẴN</Typography>
                                                        <Typography variant="h6" fontWeight="800" color="#181C32">{thongke(1)} <span style={{fontSize: '12px', color: '#A1A5B7'}}>đ</span></Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Box sx={{ p: 2, borderRadius: '12px', backgroundColor: '#F8F5FF', border: '1px solid #D8B4FE' }}>
                                                        <Typography variant="caption" fontWeight="800" color="#7239EA">TỔNG LẺ</Typography>
                                                        <Typography variant="h6" fontWeight="800" color="#181C32">{thongke(2)} <span style={{fontSize: '12px', color: '#A1A5B7'}}>đ</span></Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>

                                        </CardContent>
                                    </Card>
                                </Grid>

                                {/* PANEL PHẢI */}
                                <Grid item xs={12} lg={7}>
                                    <Card sx={{ height: '100%', backgroundColor: '#FFFFFF' }}>
                                        <CardContent sx={{ p: 4 }}>
                                            <Typography variant="subtitle1" fontWeight="800" color="#181C32" mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <CasinoOutlined color="warning" /> Can thiệp kết quả
                                            </Typography>

                                            <Box sx={{ p: 3, backgroundColor: '#181C32', borderRadius: '12px', mb: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <Typography variant="caption" color="#A1A5B7" fontWeight="700" mb={2} sx={{ textAlign: 'center !important', letterSpacing: '1px' }}>MÔ PHỎNG KẾT QUẢ SẼ RA</Typography>
                                                <Stack direction="row" spacing={3} mb={3}>
                                                    {[0, 1, 2].map(idx => (
                                                        <Box key={idx} sx={{ 
                                                            width: 60, height: 60, borderRadius: '12px', backgroundColor: selectedDice[idx] ? '#FFFFFF' : 'rgba(255,255,255,0.1)',
                                                            display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '28px', fontWeight: '900', color: '#181C32',
                                                            boxShadow: selectedDice[idx] ? 'inset 0 -4px 0 rgba(0,0,0,0.1), 0 5px 15px rgba(255,255,255,0.2)' : 'none',
                                                            border: selectedDice[idx] ? 'none' : '2px dashed rgba(255,255,255,0.3)'
                                                        }}>
                                                            <span style={{ textAlign: 'center' }}>{selectedDice[idx] || ""}</span>
                                                        </Box>
                                                    ))}
                                                </Stack>
                                                
                                                <Box sx={{ display: 'flex', gap: 2, height: '30px', alignItems: 'center' }}>
                                                    {selectedDice.length === 3 ? (
                                                        <>
                                                            <Chip label={`Tổng: ${sumDice}`} sx={{ backgroundColor: '#3F4254', color: '#FFF', fontWeight: 800, fontSize: '13px' }} />
                                                            <Chip label={txLabel} sx={{ backgroundColor: txColor === 'red' ? '#F1416C' : '#1B84FF', color: '#FFF', fontWeight: 800, fontSize: '13px' }} />
                                                            <Chip label={clLabel} sx={{ backgroundColor: '#50CD89', color: '#FFF', fontWeight: 800, fontSize: '13px' }} />
                                                        </>
                                                    ) : (
                                                        <Typography variant="body2" color="#7E8299" fontWeight="500">Vui lòng chọn 3 viên xúc xắc bên dưới...</Typography>
                                                    )}
                                                </Box>
                                            </Box>

                                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 4, flexWrap: 'wrap' }}>
                                                {[1, 2, 3, 4, 5, 6].map(num => renderDiceFace(num))}
                                            </Box>

                                            <Stack direction="row" spacing={2} justifyContent="center" mb={4}>
                                                <Button variant="outlined" color="inherit" onClick={clearDice} disabled={selectedDice.length === 0} sx={{ fontWeight: 800, borderRadius: '8px', px: 4, color: '#7E8299', borderColor: '#E4E6EF' }}>
                                                    XÓA CHỌN LẠI
                                                </Button>
                                                <Button variant="contained" color="primary" onClick={handleDiceSubmit} disabled={selectedDice.length !== 3} sx={{ fontWeight: 800, borderRadius: '8px', px: 5, boxShadow: 'none' }}>
                                                    LƯU KẾT QUẢ NÀY
                                                </Button>
                                            </Stack>

                                            <Divider sx={{ mb: 3 }}>
                                                <Chip label="Hoặc cài đặt nhanh" size="small" sx={{ color: '#A1A5B7', fontWeight: 700 }} />
                                            </Divider>

                                            <Box display="flex" gap={2} flexWrap="wrap" justifyContent="space-between" alignItems="center">
                                                <Stack direction="row" spacing={1}>
                                                    <Button variant="contained" sx={{ bgcolor: '#50CD89', color: '#fff', fontWeight: 800, boxShadow: 'none', '&:hover':{bgcolor: '#39b572'} }} onClick={() => handleQuickSubmit("224")}>CHẴN (8)</Button>
                                                    <Button variant="contained" sx={{ bgcolor: '#7239EA', color: '#fff', fontWeight: 800, boxShadow: 'none', '&:hover':{bgcolor: '#5d2bd1'} }} onClick={() => handleQuickSubmit("122")}>LẺ (5)</Button>
                                                    <Button variant="contained" sx={{ bgcolor: '#F1416C', color: '#fff', fontWeight: 800, boxShadow: 'none', '&:hover':{bgcolor: '#d93a61'} }} onClick={() => handleQuickSubmit("445")}>TÀI (13)</Button>
                                                    <Button variant="contained" sx={{ bgcolor: '#1B84FF', color: '#fff', fontWeight: 800, boxShadow: 'none', '&:hover':{bgcolor: '#1771d9'} }} onClick={() => handleQuickSubmit("123")}>XỈU (6)</Button>
                                                </Stack>

                                            </Box>

                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>

                            {/* ========================================= */}
                            {/* BẢNG DANH SÁCH NGƯỜI CHƠI                 */}
                            {/* ========================================= */}
                            <Card sx={{ backgroundColor: '#FFFFFF', mb: 4 }}>
                                <Box sx={{ p: 2.5, borderBottom: '1px solid #EFF2F5', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="h6" fontWeight="800" color="#181C32" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <GroupOutlined color="primary" /> Danh Sách Người Chơi Kỳ Này
                                    </Typography>
                                    <Chip label={`Tổng: ${current ? current.length : 0} đơn cược`} size="small" sx={{ backgroundColor: '#F1FAFF', color: '#1B84FF', fontWeight: 800 }} />
                                </Box>
                                <TableContainer sx={{ overflowX: 'auto', maxHeight: '400px' }}>
                                    <Table stickyHeader sx={{ minWidth: 1460 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', backgroundColor: '#FFFFFF' }}>Tài Khoản</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', backgroundColor: '#FFFFFF' }}>Cửa Cược</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', backgroundColor: '#FFFFFF' }}>Số Tiền</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', textAlign: 'right !important', backgroundColor: '#FFFFFF' }}>Thời Gian</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {current && current.length > 0 ? current.map((item, idx) => {
                                                const label = getBetLabel(item.state);
                                                const isTai = label.includes("TÀI") || label.includes("LẺ");
                                                return (
                                                    <TableRow key={idx} hover>
                                                        <TableCell>
                                                            <Typography variant="body2" fontWeight="800" color="#2563EB">{item?.user?.username || 'Ẩn danh'}</Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Chip 
                                                                label={label || item.state} 
                                                                size="small" 
                                                                sx={{ 
                                                                    fontWeight: 800, borderRadius: '6px', px: 1,
                                                                    backgroundColor: isTai ? '#FFF5F8' : '#F1FAFF', 
                                                                    color: isTai ? '#F1416C' : '#1B84FF' 
                                                                }} 
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography variant="body2" fontWeight="800" color="#16A34A">
                                                                {Number(item.money).toLocaleString("vi-VN")} đ
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell sx={{ textAlign: 'right !important', color: "text.secondary", fontSize: "0.8rem", fontWeight: "600" }}>
                                                            {formatDate(new Date(item.createdAt))}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }) : (
                                                <TableRow>
                                                    <TableCell colSpan={4} align="center" sx={{ py: 6, color: '#A1A5B7', fontWeight: 600 }}>
                                                        Chưa có người chơi nào cược trong kỳ này
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>

                            {/* ========================================= */}
                            {/* BẢNG LỊCH SỬ KẾT QUẢ VÀ SỬA AI RESULT     */}
                            {/* ========================================= */}
                            <Card sx={{ backgroundColor: '#FFFFFF' }}>
                                <Box sx={{ p: 2.5, borderBottom: '1px solid #EFF2F5' }}>
                                    <Typography variant="h6" fontWeight="800" color="#181C32">Phiên Tiếp Theo</Typography>
                                </Box>
                                <Box sx={{ overflowX: 'auto' }}>
                                    <Table sx={{ minWidth: 1465 }}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase' }}>Kỳ quay</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase' }}>Kết quả Thật</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', backgroundColor: '#F8F9FA' }}>Kết quả Bot AI hiển thị</TableCell>
                                                <TableCell sx={{ color: '#A1A5B7 !important', fontWeight: '800 !important', textTransform: 'uppercase', textAlign: 'right !important' }}>Thời gian</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {list30 ? list30
                                                .filter((item) => !bet || !bet.id_bet ? true : Number(item.id_bet) >= Number(bet.id_bet))
                                                .sort((a, b) => Number(a.id_bet) - Number(b.id_bet))
                                                .map((item, idx) => {
                                                    const isCurrent = item.id_bet === bet?.id_bet;
                                                    if (!isCurrent && !item.result) return null;
                                                    
                                                    return (
                                                        <TableRow key={item._id || idx} sx={{ backgroundColor: isCurrent ? '#FFF8DD' : 'inherit', transition: 'background-color 0.3s' }}>
                                                            
                                                            {/* CỘT 1: ID PHIÊN */}
                                                            <TableCell>
                                                                <Typography variant="body2" fontWeight={isCurrent ? 800 : 700} color={isCurrent ? '#FFC700' : '#181C32'}>
                                                                    #{item?.id_bet} {isCurrent && "(Đang chạy)"}
                                                                </Typography>
                                                            </TableCell>
                                                            
                                                            {/* CỘT 2: SỬA KẾT QUẢ THẬT (ẢNH HƯỞNG TIỀN) */}
                                                            <TableCell>
                                                                <form style={{ display: 'flex', gap: '8px', alignItems: 'center' }} onSubmit={(e) => {
                                                                    e.preventDefault();
                                                                    const rawVal = e.target.result.value;
                                                                    if (!rawVal) return;
                                                                    const digits = String(rawVal).replace(/[^1-6]/g, '');
                                                                    if (digits.length !== 3) return swal("Lỗi", "Vui lòng nhập đúng 3 số từ 1 đến 6", "warning");
                                                                    axios.post(`${process.env.REACT_APP_API_URL}/TX60s/update`, { id_bet: item._id, result: digits })
                                                                        .then(() => { swal(t('success'), `Sửa KQ thật phiên ${item.id_bet} thành công`, "success"); reloadHistorySilently(); })
                                                                        .catch(() => swal(t('error'), "Lỗi kết nối", "error"));
                                                                }}>
                                                                    <Typography variant="body2" fontWeight="800" color="#3F4254" sx={{ width: '40px' }}>
                                                                        {item.result || "---"}
                                                                    </Typography>
                                                                    <input 
                                                                        name="result" type="text" placeholder="Nhập 3 số..." maxLength="3"
                                                                        style={{ width: '90px', padding: '6px 10px', border: '1px solid #E4E6EF', borderRadius: '6px', outline: 'none', fontWeight: 700, textAlign: 'center' }} 
                                                                    />
                                                                    <Button type="submit" variant="contained" size="small" sx={{ backgroundColor: '#F1FAFF', color: '#1B84FF', boxShadow: 'none', fontWeight: 800, '&:hover': {backgroundColor: '#1B84FF', color: '#FFF'} }}>
                                                                        SỬA THẬT
                                                                    </Button>
                                                                </form>
                                                            </TableCell>

                                                            {/* CỘT 3: SỬA KẾT QUẢ BOT AI (CHỈ ĐỂ LÙA GÀ KHÔNG TRỪ TIỀN) */}
                                                            <TableCell sx={{ backgroundColor: isCurrent ? 'rgba(255,255,255,0.4)' : '#F8F9FA' }}>
                                                                <form style={{ display: 'flex', gap: '8px', alignItems: 'center' }} onSubmit={(e) => {
                                                                    e.preventDefault();
                                                                    const rawVal = e.target.ai_result.value;
                                                                    if (!rawVal) return;
                                                                    const digits = String(rawVal).replace(/[^1-6]/g, '');
                                                                    if (digits.length !== 3) return swal("Lỗi", "Vui lòng nhập đúng 3 số từ 1 đến 6", "warning");
                                                                    handleAISubmit(item._id, digits);
                                                                }}>
                                                                    <Typography variant="body2" fontWeight="900" color="#009EF7" sx={{ width: '40px' }}>
                                                                        {item.ai_result || "---"}
                                                                    </Typography>
                                                                    <input 
                                                                        name="ai_result" type="text" placeholder="Nhập 3 số..." maxLength="3"
                                                                        style={{ width: '90px', padding: '6px 10px', border: '1px solid #B5E4CA', borderRadius: '6px', outline: 'none', fontWeight: 700, textAlign: 'center', backgroundColor: '#E8FFF3', color: '#009EF7' }} 
                                                                    />
                                                                    <Button type="submit" variant="contained" size="small" sx={{ backgroundColor: '#009EF7', color: '#FFF', boxShadow: 'none', fontWeight: 800, '&:hover': {backgroundColor: '#0075FF', color: '#FFF'} }}>
                                                                        SỬA BOT
                                                                    </Button>
                                                                </form>
                                                            </TableCell>
                                                            
                                                            {/* CỘT 4: THỜI GIAN */}
                                                            <TableCell sx={{ textAlign: 'right !important' }}>
                                                                <Typography variant="caption" color="text.secondary" fontWeight="600">
                                                                    {formatDate(new Date(item.createdAt))}
                                                                </Typography>
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })
                                            : null}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Card>

                        </Container>
                    </Box>
                </ThemeProvider>
            </DashboardLayout>
        </ThemeProvider>
    );
}

export default SetTX;